<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © eeasy Payment Services LLC.
            </div>
            <div class="col-sm-6">
               
            </div>
        </div>
    </div>
</footer>